import GenericController from '../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.userId = this.$stateParams.id;
        this.isCurrentSuperUser = false;
        this.users = [];
        this.ApiAccountService.getUserDetails().then(()=>{
            this.getUsers();
        })
    }

    _setIsCurrentSuperUser() {

        for (let user of this.users) {
            if (user.id == this.userId) {
                this.isCurrentSuperUser = user.is_superuser && user.user.pk == this.ApiAccountService.getUserPk();
                break;
            }
        }
    }

    getUsers() {
        this._PanelsService.getPanelUsersByPanelId(this.panelId)
            .then(r => {
                this.users = r.data.results;
                this._setIsCurrentSuperUser();
            })
    }

    deleteUser(user) {

        this._PanelsService.deleteCloudPanelUser(this.panelId, user.id)
            .then(() => {
                this.toaster.pop("success", "Success", "User deleted");
                this.getUsers();
            })
            .catch(() => {
                this.toaster.pop("error", "Error", "Something went wrong please try again later");
            })
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/cloudAccounts.component/controller.js
 **/